import { StoreItem, CustomizationCategory } from './types';
import {
    EmojiIcon,
    SettingsIcon,
    TrophyIcon,
    PlusIcon,
    GlobeIcon,
    SparklesIcon,
    ImageIcon
} from './components/Icons';

export const STORE_ITEMS: StoreItem[] = [
    {
        id: 'classic_postcards',
        name: 'Classic Postcard',
        description: 'The standard rounded corner box of your theme.',
        price: 0,
        artist: 'vibeman1',
        category: 'postcards',
        previewData: { type: 'postcard' }
    },
    {
        id: 'postcard_full',
        name: 'Full Screen',
        description: 'Sharp corners, edge-to-edge content. No margins.',
        price: 0,
        artist: 'vibeman1',
        category: 'postcards',
        previewData: { type: 'postcard_full' }
    },
    {
        id: 'postcard_sticky',
        name: 'Sticky Classic',
        description: 'Classic rounded corners, but stuck together without gaps.',
        price: 0,
        artist: 'vibeman1',
        category: 'postcards',
        previewData: { type: 'postcard' }
    },
    // Default "classic" items for each category
    { id: 'classic_animations', name: 'Classic Animations', description: 'Standard app transitions.', price: 0, artist: 'vibeman1', category: 'animations' },
    { id: 'classic_bubbles', name: 'Classic Bubbles', description: 'Standard chat bubbles.', price: 0, artist: 'vibeman1', category: 'bubbles' },
    { id: 'classic_stickers', name: 'Classic Stickers', description: 'Standard sticker set.', price: 0, artist: 'vibeman1', category: 'stickers' },
    { id: 'classic_themes', name: 'Classic Themes', description: 'Standard app color palettes.', price: 0, artist: 'vibeman1', category: 'themes' },
    { id: 'classic_icons', name: 'Classic Icons', description: 'Standard interface icons.', price: 0, artist: 'vibeman1', category: 'icons' },
    { id: 'classic_fonts', name: 'Classic Fonts', description: 'Standard system fonts.', price: 0, artist: 'vibeman1', category: 'fonts' },
    { id: 'classic_pfp_themes', name: 'Classic PFP Themes', description: 'Standard profile picture frames.', price: 0, artist: 'vibeman1', category: 'pfp_themes' },
    { id: 'classic_navbar', name: 'Classic Navbar', description: 'Standard navigation bar style.', price: 0, artist: 'vibeman1', category: 'navbar' },

    // Premium Placeholders
    { id: 'placeholder_animations', name: 'Premium Animations', description: 'Coming soon.', price: 1500, category: 'animations' },
    { id: 'placeholder_bubbles', name: 'Glass Bubbles', description: 'Coming soon.', price: 2000, category: 'bubbles' },
    { id: 'placeholder_stickers', name: 'Designer Stickers', description: 'Coming soon.', price: 500, category: 'stickers' },
    { id: 'placeholder_themes', name: 'Vibrant Themes', description: 'Coming soon.', price: 4000, category: 'themes' },
    { id: 'placeholder_icons', name: 'Custom Icons', description: 'Coming soon.', price: 2000, category: 'icons' },
    {
        id: 'mod_todo',
        name: 'Perfect To-Do List',
        description: 'A modular task manager with smart reminders and notifications.',
        price: 0,
        artist: 'agk',
        category: 'mods',
        previewData: { type: 'mod' }
    },
    {
        id: 'mod_art_class',
        name: 'Art Class',
        description: 'The ultimate creator studio for postcards and stickers.',
        price: 0,
        artist: 'vibeman1',
        category: 'mods',
        previewData: { type: 'mod' }
    },
    {
        id: 'mod_daily_footprint',
        name: 'Daily Footprint',
        description: 'Track your daily impact and earn Lyfe Points.',
        price: 0,
        artist: 'vibeman1',
        category: 'mods',
        previewData: { type: 'mod' }
    },
];

export const CATEGORIES: { id: CustomizationCategory, name: string, icon: any }[] = [
    { id: 'postcards', name: 'Postcards', icon: ImageIcon },
    { id: 'animations', name: 'Animations', icon: SparklesIcon },
    { id: 'bubbles', name: 'Chat Bubbles', icon: GlobeIcon },
    { id: 'stickers', name: 'Stickers', icon: EmojiIcon },
    { id: 'themes', name: 'Themes', icon: TrophyIcon },
    { id: 'icons', name: 'Icons', icon: SettingsIcon },
    { id: 'mods', name: 'Mods', icon: SparklesIcon },
    { id: 'more', name: 'More', icon: PlusIcon },
];
